import _ from "lodash";
import type { ComponentType } from "react";
import { connect } from "react-redux";
import unlockModalConfig from "pro-features/components/Modals/src/UnlockModal/unlockModalConfig";
import { closeUnlockModal } from "app/actions/unlockModalActions";
import UnlockModalWrapper from "../UnlockModalProvider/UnlockModalProvider";

const getConfigByName = (unlockHook) => unlockModalConfig()[unlockHook];

const InnerModal = (props) => {
    const {
        modal = "",
        slide = "",
        isNoTouch = false,
        location = `Hook PRO/${modal}/${slide}/Unlock Module`,
        onOpen = _.noop,
        onClose = _.noop,
    } = props.unlockHook || {};

    const config = getConfigByName(modal);

    return (
        <UnlockModalWrapper
            isOpen={props.isOpen}
            onCloseClick={_.flow(props.closeModal, onClose)}
            location={location}
            activeSlide={slide}
            onAfterOpen={onOpen}
            isNoTouch={isNoTouch}
            {...config}
        />
    );
};

const mapStateToProps = ({ unlockModal }) => unlockModal;

function mapDispatchToProps(dispatch) {
    return {
        closeModal: () => {
            dispatch(closeUnlockModal());
        },
    };
}

export const AccessDeniedModal = connect(mapStateToProps, mapDispatchToProps)(InnerModal) as ComponentType<any>;
